import { Injectable, Injector } from '@angular/core';
import { Pib } from '@app-routes/pib/pib.model';
import { DataService } from '@app-services/data.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable()
export class PibService extends DataService {

  private reportUrl: string;

  constructor(http: HttpClient) {
    const pibUrl = environment.api_base_url + '/';
    super(pibUrl, http);
    this.reportUrl = pibUrl + "/pib/report/";
  }

  getAllPib(params: string = '') {
    const projection = 'pib?projection=pibTableProjection' + params;
    return this.getAll(projection).pipe(map((data: any) => { return data._embedded.pib as Pib[]; }));
  }

  searchPib(field: string, query: string, params: string = '') {
    // field will be 'companyName' or 'instructorName' mapping to 'company' or 'instructor' resources
    const resource = field === 'companyName' ? 'company' : 'instructor';
    const projection = `pib/search/${resource}?name=${query}&projection=pibTableProjection` + params;
    return this.getAll(projection).pipe(map((data: any) => { return data._embedded.pib as Pib[]; }));
  }

  getReportFile(id: number) {
    return this.http.get(this.url + "pib/" + id + "/report", { responseType: "blob" });
  }

  getReportsZip(id: number) {
    return this.http.get(this.url + "pib/" + id + "/zip", { responseType: "blob" });
  }

  setReportReadySTEP(id: number, sendmail: boolean) {
    return this.http.get(this.reportUrl + id + "/reportreadystep?sendmail=" + sendmail);
  }

  setReportReadyCompany(id: number, sendmail: boolean) {
    return this.http.get(this.reportUrl + id + "/reportreadycompany?sendmail=" + sendmail);
  }

}
